/*
 * Spectrum TGIF Tabs + Carousel
 * Drives the custom-top-comfort-picks section:
 *   - Pill tabs swap which product panel is visible (no URL change).
 *   - Each panel / bestsellers row is a horizontal snap-carousel with
 *     prev/next arrows that disable at the scroll bounds.
 * Vanilla, idempotent, no dependencies.
 */
(function () {
  'use strict';

  /* ---- Carousel helpers ---- */
  function cardStep(track) {
    var first = track.querySelector('.tcp__item');
    if (!first) { return track.clientWidth * 0.8; }
    var gap = parseInt(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '16', 10) || 16;
    return first.getBoundingClientRect().width + gap;
  }

  function syncArrows(car) {
    var track = car.querySelector('[data-tcp-track]');
    if (!track) { return; }
    var prev = car.querySelector('[data-tcp-arrow="prev"]');
    var next = car.querySelector('[data-tcp-arrow="next"]');
    var max = track.scrollWidth - track.clientWidth - 2;
    if (prev) { prev.disabled = track.scrollLeft <= 2; }
    if (next) { next.disabled = track.scrollLeft >= max; }
  }

  function syncWithin(scope) {
    (scope || document).querySelectorAll('.tcp__carousel').forEach(syncArrows);
  }

  /* ---- Tab switching ---- */
  document.querySelectorAll('[data-tcp-tabs]').forEach(function (grp) {
    var tabs = grp.querySelectorAll('.tcp__tab');
    var panels = grp.querySelectorAll('.tcp__panel');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var idx = tab.getAttribute('data-tcp-tab');
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          var on = p.getAttribute('data-tcp-panel') === idx;
          p.classList.toggle('is-active', on);
          if (on) {
            p.removeAttribute('hidden');
            /* Panel was display:none until now — recompute arrow bounds
               once it has real layout dimensions. */
            syncWithin(p);
          } else {
            p.setAttribute('hidden', '');
          }
        });
      });
    });
  });

  /* ---- Carousel arrows ---- */
  document.querySelectorAll('.tcp__carousel').forEach(function (car) {
    var track = car.querySelector('[data-tcp-track]');
    if (!track) { return; }
    car.querySelectorAll('[data-tcp-arrow]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = btn.getAttribute('data-tcp-arrow') === 'next' ? 1 : -1;
        track.scrollBy({ left: dir * cardStep(track), behavior: 'smooth' });
      });
    });
    track.addEventListener('scroll', function () { syncArrows(car); }, { passive: true });
    syncArrows(car);
  });

  window.addEventListener('resize', function () { syncWithin(document); }, { passive: true });
})();
